import React from 'react';
import classNames from 'classnames';
import config from '../../common/config';

export default ({
  name,
  imageUrl,
  facilityName,
  license,
  state,
  category,
  cbdContent,
  cbdContentUnitOfMeasure,
  cbdContentDose,
  cbdContentDoseUnitOfMeasure,
  cbdPotency,
  thcContent,
  thcContentUnitOfMeasure,
  thcContentDose,
  thcContentDoseUnitOfMeasure,
  thcPotency,
  retailAvailability,
  className,
  onClick = () => {},
  onKeyDown = (e) => { if (e.keyCode === 13) onClick(); },
}) => (
  <div className={classNames('item-grid-result', className)} onClick={onClick} onKeyDown={onKeyDown} role="button" tabIndex={0}>
    <img src={`${config.imageServerUrl}${imageUrl}`} alt={name} />
    <div className="content">
      <div className="d-flex">
        <div className="name">{name}</div>
        <div className="state ml-auto">{state}</div>
      </div>
      <div className="category">{category}</div>
      <div className="cbd">
        <div className="row">
          <div className="col">
            {thcPotency && `THC: ${thcPotency}%`}
          </div>
          <div className="col">
            {cbdPotency && `CBD: ${cbdPotency}%`}
          </div>
        </div>
        <div className="row">
          <div className="col">
            {thcContent && `THC: ${thcContent}`}{thcContentUnitOfMeasure && `${thcContentUnitOfMeasure}`}{thcContent && <br />}
          </div>
          <div className="col">
            {cbdContent && `CBD: ${cbdContent}`}{cbdContentUnitOfMeasure && `${cbdContentUnitOfMeasure}`}{cbdContent && <br />}
          </div>          
        </div>
        <div className="row">
          <div className="col-6 col-sm-12">
            {thcContentDose && `THC Dose: ${thcContentDose}`}{thcContentDoseUnitOfMeasure && `${thcContentDoseUnitOfMeasure}`}
          </div>
          <div className="col-6 col-sm-12">
            {cbdContentDose && `CBD Dose: ${cbdContentDose}`}{cbdContentDoseUnitOfMeasure && `${cbdContentDoseUnitOfMeasure}`}
          </div>          
        </div>
      </div>
      <div className="facility">{facilityName}</div>
      <div className="license">{license}</div>
      {retailAvailability && <div>{retailAvailability.length} additional license(s)</div>}
    </div>
  </div>
);
